import Endpoints from "../config/endpoints"
import Request from "../helpers/request"
import RequestV2 from "../helpers/request-v2"
import _ from 'lodash'

export default class EadRequests {

    static getAccount(code, ignoreReleaseDescription = true) {
        return RequestV2
            .getInstance()
            .createGetRequest(`${Endpoints.account.get}/${code}`, {ignoreReleaseDescription})
    }


    static searchEADModules(filter) {
        return Request
            .getInstance()
            .createGetRequest(Endpoints.ead.module.search, filter, {})
            .then(result => result || null)
    }


    static searchEadUser(filter) {
        return Request
            .getInstance()
            .createGetRequest(Endpoints.ead.user.search, filter, {})
            .then(result => _.get(result, 'user[0]', null))
    }


    static searchEadUserTrack(filter) {
        return Request
            .getInstance()
            .createGetRequest(Endpoints.ead.userTrack.search, filter, {})
            .then(result => result || null)
    }


    static saveUserTrack(userTrack) {

        console.log('UserTrack > ', userTrack)
        const utk = {
            status: userTrack.status,
            contentDTO: userTrack.contentDTO,
            userDTO: userTrack.userDTO
        }

        if(userTrack.code !== undefined)
            utk.code = userTrack.code
        if(userTrack.startDate !== undefined)
            utk.startDate = userTrack.startDate

        return Request
            .getInstance()
            .createPostRequest(Endpoints.ead.userTrack.save, utk, {})
    }


    static getUserProgress(prsCode, accCode) {

        return RequestV2
            .getInstance()
            .createGetRequest(
                Endpoints.ead.user.progress,
                {
                    prsCode,
                    accCode
                })
    }


    static searchForums(filter) {
        return Request
            .getInstance()
            .createGetRequest(Endpoints.ead.forum.search, filter, {})
    }

    static searchTutorTopics(filter) {
        return Request
            .getInstance()
            .createGetRequest(Endpoints.ead.forumTopic.tutor, filter, {})
    }


    static getForumTopic(id) {
        return Request
            .getInstance()
            .createGetRequest(Endpoints.ead.forumTopic.get + "/" + id, {}, {})
    }

    static saveForumTopic(forumTopicDTO) {
        return Request
            .getInstance()
            .createGetRequest(Endpoints.ead.forumTopic.save, forumTopicDTO, {})
    }


    static searchForumPosts(filter) {
        return Request
            .getInstance()
            .createGetRequest(Endpoints.ead.forumPosts.search, filter, {})
    }


    static saveForumPost(forumPostDTO) {
        return Request
            .getInstance()
            .createPostRequest(Endpoints.ead.forumPosts.save, forumPostDTO, {})
    }

    static searchUserForms(filter){
        return Request
            .getInstance()
            .createGetRequest(Endpoints.ead.userForm.get, filter, {})
    }

    static searchUserAnswers(filter){
        return RequestV2
            .getInstance()
            .createGetRequest(Endpoints.ead.userAnswer.search, filter)
    }

    static saveUserAnswers(userAnswers) {
        return RequestV2
            .getInstance()
            .createPostRequest(Endpoints.ead.userAnswer.save, {useranswer: userAnswers})
    }

    static consolidateFormData(params) {
        return RequestV2
            .getInstance()
            .createGetRequest(Endpoints.ead.userForm.consolidate, params)
    }

    static generateCertificate(params) {
        return RequestV2
            .getInstance()
            .createGetRequest(Endpoints.release.certificate, params, {}, false, true, true)
    }
}



// WEBPACK FOOTER //
// ./src/requests/ead-requests.js